import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {CategoryProps} from 'modules/categories/types';
import categoriesKeys from 'modules/categories/util/categories-keys';
import React from 'react';
import {BiSortAlt2} from 'react-icons/bi';
import {IoTrash} from 'react-icons/io5';
import {useNavigate} from 'react-router-dom';
import List from 'shared/layout/list';
import ApiDynamicButton from 'shared/migration-components/api-dynamic-button';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';

const Categories: React.FC = () => {
  const projection = useProjection<CategoryProps>(
    'categories',
    ['name', 'active', 'companyName', 'cityName', 'id'],
    {orderBy: {field: 'orderIndex', order: 1}},
  );
  const {companyId, cityId} = useAccessControls();
  const navigate = useNavigate();

  return (
    <List<CategoryProps>
      {...{
        titleBar: {
          title: 'Categorias',
          actionButton: {title: 'NOVA CATEGORIA', to: 'create'},
        },
        table: {
          url: '/categories',
          toolbar: [
            {
              label: 'Ordenação no app',
              icon: <BiSortAlt2 />,
              onClick: () => navigate('reorder'),
            },
          ],
          projection: {
            ...projection,
            options: [
              'name',
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      isChecked={row.active}
                      url={`/categories/${row.id}`}
                      queryKey={categoriesKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
              {
                value: 'companyName',
                hidden: !!companyId,
              },
              {value: 'cityName', hidden: !!companyId || !!cityId},
              {
                value: 'id',
                label: 'Ações',
                column: (row) => (
                  <ApiDynamicButton
                    keys={{deleteInfiniteList: categoriesKeys.list()}}
                    button={{icon: <IoTrash />, tooltip: 'Remover categoria'}}
                    request={{
                      errorTitle: 'Erro ao remover categoria',
                      method: 'DELETE',
                      url: `/categories/${row.id}`,
                    }}
                    confirmButtonText="categoria"
                  />
                ),
              },
            ],
          },
          translatedPropsKey: 'CategoryProps',
        },
        queryKey: categoriesKeys.list(),
        extraParams: companyId
          ? {
              companyId: {operator: 'equals', value: companyId},
            }
          : undefined,
      }}
    />
  );
};

export default Categories;
